module.exports = __webpack_public_path__ + "static/media/globalHealth.f06f7c9c.png";